<template>
  <div class="box">
    <div class="box2">
      <div class="headerBox">
        <div class="back" v-on:click="back">
          <img src="../assets/GoBack2.png" alt />
        </div>
        优惠券活动
      </div>
      <div class="typeList">
        <div
          v-for="(item, index) in ShopClassList"
          :class="'typeLi ' + (shopTypeName == item ? 'clickType' : '')"
          v-on:click="clickType(item)"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <div class="couponBox">
        <div class="couponLi" v-for="(item, index) in couponList" :key="index">
          <div class="couponType">{{ item.coupontype_name }}</div>
          <div class="couponInfo">
            <div>·{{ item.shop_name }}</div>
            <div v-if="item.coupontype_name == '免费券'">
              ·{{
                item.name
                  ? "免费商品：" + item.name
                  : "免费金额：" + item.amount + "元"
              }}
            </div>
            <div v-else-if="item.coupontype_name == '礼品券'">
              ·购：{{ item.gift }}
            </div>
            <div v-else-if="item.coupontype_name == '优惠券'">
              ·满{{ item.reduce_rule }}
            </div>

            <div v-if="item.coupontype_name == '免费券'">
              ·限领数量：{{ item.limitnumber }}
            </div>
            <div v-else-if="item.coupontype_name == '礼品券'">
              ·送：{{ item.name }}
            </div>
            <div v-else-if="item.coupontype_name == '优惠券'">
              ·减{{ item.amount }}
            </div>

            <div v-on:click="watchRule(item.use_rule)">
              ·{{ item.use_rule }}
            </div>
            <div>·截止：{{ item.end_time.substring(0, 11) }}</div>

            <!-- <div>· {{ item.shopclass_name }}</div>
            <div>· 满50</div>
            <div>· 减50</div>
            <div>· 有效期至：{{ item.end_time }}</div> -->
          </div>
          <div class="shopJL">{{ item.juli }}m</div>
          <div class="imgClick" v-on:click="clickCoupon(index)">
            <img v-if="item.inShopCar" src="../assets/couponClick.png" alt="" />
            <img v-else src="../assets/couponNo.png" alt="" />
          </div>
        </div>
        <div v-if="couponList.length == 0" class="noInfo">暂无更多数据</div>
      </div>
    </div>
    <div class="shopCar">
      <div class="AllNum" v-on:click="watchCar">
        <img src="../assets/shopCar.png" alt="" />
        <div>{{ shopCarCoupon.length }}</div>
      </div>
      <div class="textBox">
        <div>已选择价值{{ Allmoney }}元券</div>
        <div>还能选择价值{{ lastMoney }}元券</div>
      </div>
      <div class="btn" v-on:click="makesuer">提交</div>
    </div>
    <div class="ModleBottom" v-if="watchCarBox">
      <div v-on:click="watchCar" style="height: 100%; width: 100%"></div>
      <div class="showCarInfo">
        <!-- <img src="../assets/close.png" alt=""> -->
        <yd-accordion accordion v-if="shopCouponList.length > 0">
          <yd-accordion-item
            v-for="(item, index) in shopCouponList"
            :key="index"
            :title="item.shop_name"
            open
          >
            <div
              class="ShopCouponLi"
              v-for="(coupon, idx) in item.CouponList"
              :key="idx"
            >
              <div class="LiLeft" v-if="coupon.coupontype_name == '免费券'">
                {{ coupon.amount }}元 {{ coupon.coupontype_name }}
              </div>
              <div class="LiLeft" v-if="coupon.coupontype_name == '优惠券'">
                满{{ coupon.reduce_rule }}减{{ coupon.amount }}元
                {{ coupon.coupontype_name }}
              </div>
              <div class="LiLeft" v-if="coupon.coupontype_name == '礼品券'">
                {{ coupon.amount }}元 {{ coupon.coupontype_name }}
              </div>
              <div class="LiRight">
                <div class="CouponReduice" v-on:click="reduceNum(index, idx)">
                  -
                </div>
                <div>{{ coupon.shopCarNum }}</div>
                <div class="CouponAdd" v-on:click="addNum(index, idx)">+</div>
              </div>
            </div>
          </yd-accordion-item>
        </yd-accordion>
        <div class="noCar" v-else>购物车空空如也！</div>
      </div>
    </div>

    <div class="openWindow" v-if="showReasult">
      <div class="showReasult">
        <img v-if="true" src="../assets/getSuccess.png" alt="" />
        <img v-else src="../assets/getFail.png" alt="" />

        <div v-if="true" class="reasultText">提交成功</div>
        <div v-else class="reasultText">提交失败</div>
        <div v-if="true" class="hintText">
          请进入珍券公众号，点击“<span style="color: #fde0aa">我的券</span>”查看
        </div>
        <div v-else class="hintText">失败原因</div>
      </div>
      <img src="../assets/getFail.png" v-on:click="closeWindow" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      watchCarBox: false,
      showReasult: false,

      ShopClassList: [],
      shopTypeList: [],
      shopTypeName: "",
      couponList: [],
      shopCarCoupon: [],

      shopCouponList: [],
      Allmoney: 0,
      lastMoney: "",
    };
  },
  components: {},
  created() {},
  mounted() {
    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    var location = JSON.parse(localStorage.getItem("ZQlocation"));
    this.$store.commit("location", location);
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo,
    });
    this.$store.commit(
      "UserSelf",
      JSON.parse(localStorage.getItem("ZQUserSelf"))
    );
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;

    this.active_id = this.$route.query.active_id;
    this.shop_id = this.$route.query.shop_id;
    this.activeMoney = this.$route.query.activeMoney;

    this.GetShopClassListList();
    this.activity_receive_amount();
  },
  methods: {
    watchRule(rule) {
      alert(rule);
    },
    back() {
      this.$router.go(-1);
    },
    reduceNum(index, index2) {
      var coupon = this.shopCouponList[index];
      if (coupon.CouponList[index2].shopCarNum > 1) {
        coupon.CouponList[index2].shopCarNum--;
        for (var i = 0; i < this.shopCarCoupon.length; i++) {
          if (this.shopCarCoupon[i].id == coupon.CouponList[index2].id) {
            this.shopCarCoupon.splice(i, 1, coupon.CouponList[index2]);
            // this.shopCarCoupon[i].shopCarNum=.shopCarNum--;    //改变选中数据源的数量
          }
        }
      } else {
        return;
      }
      this.shopCouponList.splice(index, 1, coupon);
      this.countAllMoney();
      console.log(this.shopCouponList[index].CouponList[index2].shopCarNum);
    },
    addNum(index, index2) {
      var coupon = JSON.parse(JSON.stringify(this.shopCouponList[index]));
      if (
        coupon.CouponList[index2].shopCarNum <
        coupon.CouponList[index2].limitnumber
      ) {
        coupon.CouponList[index2].shopCarNum++;

        console.log(this.shopCarCoupon);
        var flag = this.countAllMoney(
          index,
          index2,
          coupon.CouponList[index2].shopCarNum
        );
        if (flag) {
          for (var i = 0; i < this.shopCarCoupon.length; i++) {
            if (this.shopCarCoupon[i].id == coupon.CouponList[index2].id) {
              // this.shopCarCoupon[i].shopCarNum=coupon.CouponList[index2].shopCarNum--;    //改变选中数据源的数量
              this.shopCarCoupon.splice(i, 1, coupon.CouponList[index2]);
            }
          }
          this.shopCouponList.splice(index, 1, coupon);
        }
      } else {
        this.$store.commit("showMsg", {
          show: true,
          type: false,
          msg:
            "该优惠券每人限领" + coupon.CouponList[index2].limitnumber + "张",
        }); //显示领取失败
      }
      console.log(this.shopCouponList[index].CouponList[index2].shopCarNum);
    },
    countAllMoney(index, index2, num) {
      var money = 0;
      for (var i = 0; i < this.shopCouponList.length; i++) {
        for (var j = 0; j < this.shopCouponList[i].CouponList.length; j++) {
          if (i == index && j == index2) {
            //计算价钱
            money += this.shopCouponList[i].CouponList[j].amount * num;
          } else {
            money +=
              this.shopCouponList[i].CouponList[j].amount *
              this.shopCouponList[i].CouponList[j].shopCarNum;
          }
        }
      }
      if (money > this.AllLastMoney) {
        this.$store.commit("showMsg", {
          show: true,
          type: false,
          msg: "领取的优惠券总金额不能超过活动金额",
        }); //显示领取失败
        return false;
      } else {
        this.Allmoney = money;
        this.lastMoney = this.AllLastMoney - money;
        return true;
      }
    },
    watchCar() {
      this.watchCarBox = !this.watchCarBox;
    },
    closeWindow() {
      this.showReasult = !this.showReasult;
    },
    makesuer() {
      var list = [];
      var shopCouponList = this.shopCouponList;
      for (var i = 0; i < shopCouponList.length; i++) {
        for (var j = 0; j < shopCouponList[i].CouponList.length; j++) {
          list.push({
            coupon_id: shopCouponList[i].CouponList[j].id,
            shop_id: shopCouponList[i].CouponList[j].shop_id,
            num: shopCouponList[i].CouponList[j].shopCarNum,
          });
        }
      }
      if(list.length==0){
        this.$store.commit("showMsg", {
              show: true,
              type: false,
              msg: '请先选择优惠券',
            }); //显示领取失败
        return
      }
      this.$store.commit("showLoading", true); //显示加载图标
      this.$http
        .get("/api/Activity/batch_receive", {
          params: {
            uid: this.$store.state.useId,
            activity_id: this.active_id,
            list: JSON.stringify(list),
          },
        })
        .then((res) => {
          this.$store.commit("showLoading", false); //隐藏加载图标
          if (res.data.code == 1) {
            this.$store.commit("showMsg", {
              show: true,
              type: true,
              msg: "",
            }); //显示领取成功
            //初始化数据
            this.watchCarBox = false;
            this.CouponList = [];
            this.shopCouponList = [];
            this.shopCarCoupon = [];
            this.Allmoney = 0;
            this.activity_coupon_list();
            this.activity_receive_amount();
            // setTimeout(()=>{
            //   this.$router.push({ path: "/Home"});
            // },1000)
          } else {
            this.$store.commit("showMsg", {
              show: true,
              type: false,
              msg: res.data.msg,
            }); //显示领取失败
          }
        });
    },
    activity_coupon_list() {
      this.$store.commit("showLoading", true); //显示加载图标
      this.$http
        .get("/api/Activity/activity_coupon_list", {
          params: {
            shop_id: this.shop_id,
            name: this.shopTypeName,
            log: this.$store.state.log,
            lat: this.$store.state.lat,
          },
        })
        .then((res) => {
          this.$store.commit("showLoading", false); //隐藏加载图标
          console.log(res.data);
          this.couponList = [];
          res.data.data.action.map((data) => {
            var m = 0;
            for (var i = 0; i < this.shopCarCoupon.length; i++) {
              if (this.shopCarCoupon[i].id == data.id) {
                m++;
              }
            }
            if (m != 0) {
              data.inShopCar = true;
            }
            this.couponList.push(data);
          });
        });
    },
    //获取店铺分类
    GetShopClassListList() {
      this.$http
        .get("/api/shop/getShopClassListList", {
          params: {},
        })
        .then((res) => {
          console.log(res.data);
          for (var x in res.data) {
            this.ShopClassList.push(res.data[x]);
            this.shopTypeList.push([]);
          }
          this.clickType(this.ShopClassList[0]);
        });
    },
    //获取活动已领取金额
    activity_receive_amount() {
      this.$http
        .get("/api/Activity/activity_receive_amount", {
          params: {
            uid: this.$store.state.useId,
            activity_id: this.active_id,
            // shop_id: this.shop_id,
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            this.lastMoney = this.activeMoney - res.data.data;
            this.AllLastMoney = this.activeMoney - res.data.data;
          } else {
            this.$store.commit("showLoading", false); //关闭加载图标
            this.$store.commit("showMsg", {
              show: true,
              type: false,
              msg: res.data.msg,
            }); //显示领取失败
            setTimeout(() => {
              this.back();
            },1500);
          }
        });
    },
    clickType(item) {
      this.shopTypeName = item;
      this.activity_coupon_list();
    },
    clickCoupon(index) {
      var couponList = this.couponList;
      var shopCarCoupon = this.shopCarCoupon;
      var m = 0;
      var shopCarIndex;
      this.$store.commit("showLoading", true); //显示加载图标
      this.$http
        .get("/api/Activity/is_addcart", {
          params: {
            shop_id: this.shop_id,
            uid: this.$store.state.useId,
            activity_id: this.active_id,
            coupon_id: couponList[index].id,
          },
        })
        .then((res) => {
          this.$store.commit("showLoading", false); //隐藏加载图标
          if (res.data.code == 1) {
            for (var i = 0; i < shopCarCoupon.length; i++) {
              if (shopCarCoupon[i].id == couponList[index].id) {
                m++;
                shopCarIndex = i;
              }
            }

            if (m == 0) {
              if (couponList[index].amount < this.lastMoney) {
                couponList[index].inShopCar = true;
                couponList[index].shopCarNum = 1;
                this.couponList.splice(index, 1, couponList[index]);
                this.shopCarCoupon.push(couponList[index]);
              } else {
                this.$store.commit("showMsg", {
                  show: true,
                  type: false,
                  msg: "领取的优惠券总金额不能超过活动金额",
                }); //显示领取失败
                return false;
              }
            } else {
              couponList[index].inShopCar = false;
              this.couponList.splice(index, 1, couponList[index]);
              this.shopCarCoupon.splice(shopCarIndex, 1);
            }

            var shopIdList = [];
            this.shopCouponList = [];
            //记录一分商店id
            for (var i = 0; i < this.shopCarCoupon.length; i++) {
              if (shopIdList.indexOf(this.shopCarCoupon[i].shop_id) == -1) {
                shopIdList.push(this.shopCarCoupon[i].shop_id);
                this.shopCouponList.push({
                  shop_id: this.shopCarCoupon[i].shop_id,
                  shop_name: this.shopCarCoupon[i].shop_name,
                  CouponList: [],
                });
              }
            }
            //根据商店id进行分类
            for (var i = 0; i < this.shopCarCoupon.length; i++) {
              var ids = shopIdList.indexOf(this.shopCarCoupon[i].shop_id);
              var obj = this.shopCouponList[ids];
              obj.CouponList.push(this.shopCarCoupon[i]);
              this.shopCouponList.splice(ids, 1, obj);
            }

            this.countAllMoney();

            console.log(this.shopCouponList);
          } else {
            this.$store.commit("showMsg", {
              show: true,
              type: false,
              msg: res.data.msg,
            }); //显示领取失败
          }
        });
    },
  },
};
</script>
<style lang='scss' scoped>
.headerBox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 0.3rem;
  line-height: 0.9rem;
  height: 0.9rem;
  background: #eee;
}
.back {
  position: absolute;
  top: 0.1rem;
  left: 0.2rem;
  width: 0.6rem;
  height: 0.6rem;
  z-index: 1000;
}
.back img {
  width: 100%;
  height: 100%;
  display: inline-block;
}
.noCar {
  height: 2rem;
  line-height: 2rem;
  text-align: center;
}
.noInfo {
  font-size: 0.3rem;
  text-align: center;
  margin-top: 2rem;
}
.box {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  padding-bottom: 1rem;
  overflow: hidden;
}
.box2 {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  background: white;
  overflow: hidden;
  padding-top: 0.9rem;
  box-sizing: border-box;
}
.openWindow {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba($color: #000000, $alpha: 0.7);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.openWindow > img {
  width: 0.7rem;
  height: 0.7rem;
  margin-top: 0.4rem;
  margin-bottom: 0.3rem;
}
.showReasult {
  background-image: url(../assets/openReasult.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 70%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
.showReasult > img {
  width: 1.4rem;
  height: 1.4rem;
  margin-top: 4.8rem;
}
.reasultText {
  font-size: 0.4rem;
  font-weight: 700;
  color: #fbefb5;
  margin: 0.3rem 0 0.8rem 0;
}
.hintText {
  font-size: 0.19rem;
  color: white;
}
.typeList {
  width: 1.2rem;
  flex-shrink: 0;
  background: #f5f5f5;
}
.typeLi {
  height: 0.9rem;
  line-height: 0.9rem;
  text-align: center;
  width: 100%;
  font-size: 0.26rem;
}
.clickType {
  color: #cd160d;
  background: white;
}
.couponBox {
  padding: 0.3rem 0.21rem;
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  padding-bottom: 1.2rem;
}
.couponLi {
  width: 100%;
  height: 1.8rem;
  background: url(../assets/ActionBack.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0.1rem;
}
.couponType {
  font-size: 0.28rem;
  color: #fee4ad;
  width: 1.2rem;
  flex-shrink: 0;
  text-align: center;
}
.couponInfo {
  font-size: 0.22rem;
  color: #fee4ad;
  width: 2.74rem;
  flex-shrink: 0;
}
.couponInfo > div {
  line-height: 0.35rem;
}
.shopJL {
  font-size: 0.24rem;
  color: #fee4ad;
  width: 1.12rem;
  flex-shrink: 0;
}
.imgClick {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.imgClick > img {
  width: 0.5rem;
  height: 0.5rem;
}
.shopCar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 1rem;
  border-top: 1px solid #e5e5e5;
  background: white;
  z-index: 100;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
.AllNum {
  position: relative;
  width: 20%;
  flex-shrink: 0;
  padding: 0 0.42rem;
  height: 1rem;
}
.AllNum > img {
  width: 0.6rem;
  height: 0.6rem;
  margin-top: 0.2rem;
}
.AllNum > div {
  position: absolute;
  top: 0.08rem;
  left: 0.9rem;
  background: #cd160d;
  border-radius: 100%;
  width: 0.54rem;
  height: 0.54rem;
  color: #ffe482;
  text-align: center;
  line-height: 0.54rem;
}
.textBox {
  width: 100%;
  padding-right: 0.2rem;
}
.textBox > div {
  text-align: right;
  font-size: 0.24rem;
  line-height: 0.34rem;
  color: #cd160d;
  width: 100%;
}
.textBox > div:nth-child(1) {
  color: #666;
}
.btn {
  width: 2.2rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  background: #cd160d;
  color: #fee4ad;
  flex-shrink: 0;
  font-size: 0.32rem;
}
.ModleBottom {
  height: 100%;
  width: 100%;
  position: absolute;
  bottom: 1rem;
  left: 0;
  background: rgba($color: #000000, $alpha: 0.7);
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
.showCarInfo {
  width: 100%;
  max-height: 50vh;
  flex-shrink: 0;
  overflow: scroll;
  font-size: 0.28rem;
  position: relative;
  // padding-top: 0.6rem;
  background: white;
  // border-bottom: 1px solid #e5e5e5;
}
.ShopCouponLi {
  height: 0.84rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 0 0.5rem;
}
.LiLeft {
  color: #999;
}
.LiRight {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-right: 0.2rem;
}
.LiRight > div {
  width: 0.7rem;
  height: 0.7rem;
  text-align: center;
  line-height: 0.7rem;
  font-size: 0.4rem;
}
.CouponReduice,
.CouponAdd {
  border-radius: 100%;
  border: 1px solid #b2b2b2;
}
</style>
